import styled from "styled-components";

const SensorsDataStyled = styled.div`
  .active-row {
    background: #ffe9e9 !important;
  }
`;

export { SensorsDataStyled };
